import React from 'react';
import { Plus } from 'lucide-react';

const GameCenterTab = () => {
  return (
    <div className="p-8 text-center">
      <Plus className="w-16 h-16 text-blue-500 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-gray-800 mb-2">Game Center</h3>
      <p className="text-gray-600">Game management and center operations.</p>
    </div>
  );
};

export default GameCenterTab; 